// @flow
import React from 'react'

const Spray = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="21" height="23" viewBox="0 0 21 23">
      <g fill="none" fillRule="evenodd" stroke="#6E7B8C">
        <path strokeLinecap="square" d="M7.5.5h13v4h-13z" />
        <path d="M18.5 4.5v18h-11v-6s6-4 6-12" />
        <path strokeLinecap="square" d="M.5 2.5h2M2.55 7.45l1.414-1.414" />
      </g>
    </svg>
  )
}

export default Spray



// WEBPACK FOOTER //
// ./src/components/Icons/Spray.js